var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23H20.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25H20.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 27H20.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.25L18.7969 29.3047C18.6114 29.5829 18.2992 29.75 17.9648 29.75H15.0352C14.7008 29.75 14.3886 29.5829 14.2031 29.3047L13.5 28.25H19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 21.76L19.7041 21.4622C19.8558 16.0026 24.18 17.0344 24.18 12.52C24.18 7.92499 21.095 4.2 16.5 4.2C11.905 4.2 8.82001 7.92499 8.82001 12.52C8.82001 15.6376 13.3 16 13.3 21.76",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.4e2503fe266eb03651e76559c1349a28.svg";
export { ForwardRef as ReactComponent };